import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchAccesoriesSetsHead = (startDate, endDate) => apiActionCreator({
  'endpoint': `/accessories-sets/list?startDate=${startDate}&endDate=${endDate}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_SET_SALES,
    ActionTypes.FETCHED_SET_SALES,
    [
      ActionTypes.FETCHED_SET_SALES_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const downloadSetSalesFile = (initialDate, finalDate) => apiActionCreator({
  'endpoint': `/accessories-sets/excel?startDate=${initialDate}&endDate=${finalDate}`,
  
  'authenticated': true,
  'types': [
    ActionTypes.DOWNLOADING_SET_SALE_FILE,
    {
      'type': ActionTypes.DOWNLOADED_SET_SALE_FILE,
    },
    [
      {
        'type': ActionTypes.DOWNLOADED_SET_SALE_FILE_FAILED,
      },
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchAccesoriesSetsDetail = ({
  startDateFilter,
  endDateFilter,
  customerId,
  setId,
}) =>
  apiActionCreator({
    'endpoint':
      `/accessories-sets/detail?startDate=${startDateFilter}` +
      `&endDate=${endDateFilter}&customerId=${customerId}&setCode=${setId}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_SET_SALES_DETAIL,
      ActionTypes.FETCHED_SET_SALES_DETAIL,
      [
        ActionTypes.FETCHED_SET_SALES_DETAIL_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const downloadSetSalesDetailFile = ({
  startDateFilter,
  endDateFilter},
customerId,
setId,
) =>
  apiActionCreator({
    'endpoint':
      `/accessories-sets/excelDetail?startDate=${startDateFilter}` +
      `&endDate=${endDateFilter}&customerId=${customerId}&setCode=${setId}`,
    'authenticated': true,
    'types': [
      ActionTypes.DOWNLOADING_SET_SALE_DETAIL_FILE,
      {
        'type': ActionTypes.DOWNLOADED_SET_SALE_DETAIL_FILE,
      },
      [
        {
          'type': ActionTypes.DOWNLOADED_SET_SALE_DETAIL_FILE_FAILED,
        },
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const changeSetSalesListPage = (value) => ({
  'type': ActionTypes.CHANGE_SET_SALES_LIST_PAGE,
  'payload': value,
});

export const changeSetsalesListPageSize = (value) => ({
  'type': ActionTypes.CHANGE_SET_SALES_LIST_PAGE_SIZE,
  'payload': value,
});

export const deleteAccesoriesSetsHead = (data) => ({
  'type': ActionTypes.DELETE_SET_SALES_DATA,
});

export const deleteAccesoriesSetDetail = (data) => ({
  'type': ActionTypes.DELETE_SET_SALES_DETAIL_DATA,
});

export const changeSetSalesDetailListPage = (value) => ({
  'type': ActionTypes.CHANGE_SET_SALES_DETAIL_LIST_PAGE,
  'payload': value,
});

export const changeSetSalesListDetailPageSize = (value) => ({
  'type': ActionTypes.CHANGE_SET_SALES_DETAIL_LIST_PAGE_SIZE,
  'payload': value,
});
